/**
 * Portales de cliente (mismo login Google, distinto sitio y vista).
 * localhost / nexus.plexarian.com → Nexus staff (null).
 */

function marketingEspacioPath(hostname, pathname) {
  const h = String(hostname || '').toLowerCase();
  if (h !== 'www.plexarian.com' && h !== 'plexarian.com') return false;
  const path = String(pathname || '').replace(/\/+$/, '') || '/';
  return path === '/espacio' || path === '/clientes';
}

/** @returns {'licencias' | 'espacio' | 'capacitaciones' | 'soporte' | null} */
export function getClientPortalKind(
  hostname = typeof window !== 'undefined' ? window.location.hostname : '',
  search = typeof window !== 'undefined' ? window.location.search : '',
  pathname = typeof window !== 'undefined' ? window.location.pathname : ''
) {
  if (marketingEspacioPath(hostname, pathname)) return 'espacio';

  const params = new URLSearchParams(search || '');
  const portal = (params.get('portal') || '').toLowerCase();

  if (portal === 'support' || portal === 'soporte' || params.get('mode') === 'support') {
    return 'soporte';
  }
  if (portal === 'skillsync' || portal === 'capacitaciones' || params.get('mode') === 'capacitaciones') {
    return 'capacitaciones';
  }
  if (portal === 'espacio' || portal === 'clientes' || params.get('mode') === 'espacio') {
    return 'espacio';
  }
  if (portal === 'licencias' || portal === 'client' || params.get('mode') === 'licencias') {
    return 'licencias';
  }

  const h = (hostname || '').toLowerCase();
  // Un canal de Firebase puede llamarse "capacitaciones-…" y no por eso es el portal.
  if (h.endsWith('.web.app') || h.endsWith('.firebaseapp.com')) return null;
  if (h === 'soporte.plexarian.com' || h.startsWith('soporte.')) return 'soporte';
  if (h.includes('skillsync')) return 'capacitaciones';
  if (h.includes('capacitacion')) return 'capacitaciones';
  if (h === 'clientes.plexarian.com' || h === 'espacio.plexarian.com') return 'espacio';
  if (h.includes('licencias')) return 'licencias';
  if (h.includes('plexarian.mx')) return 'licencias';

  return null;
}

export function isAnyClientPortalHost(hostname, search) {
  return getClientPortalKind(hostname, search) != null;
}

/** @deprecated use getClientPortalKind / isAnyClientPortalHost */
export function isClientPortalHost(hostname, search) {
  return isAnyClientPortalHost(hostname, search);
}

export function isLicenciasPortalHost(hostname, search) {
  return getClientPortalKind(hostname, search) === 'licencias';
}

/**
 * licencias.plexarian.com: vacío si puede entrar; texto si hay que negarlo.
 * Entran administradores de consola y las personas que ellos autorizaron.
 */
export function licenciasPortalBlockMessage(session) {
  if (session?.modules?.licenses) return '';
  if (session?.adminLookup === 'unavailable') {
    return 'No pudimos confirmar si administras la consola. Por favor intenta de nuevo en unos minutos.';
  }
  return 'Este portal es solo para administradores de Google Workspace y para las personas que ellos autorizaron a solicitar licencias. Por favor contacta primero al administrador de tu dominio para que te dé permiso. Si necesitas ayuda, con gusto te atendemos en soporte.plexarian.com.';
}

export function isCapacitacionesPortalHost(hostname, search) {
  return getClientPortalKind(hostname, search) === 'capacitaciones';
}

/** En el espacio, licencias o SkillSync del cliente, una sesión @plexarian.com no abre Nexus. */
export function clientPortalBlocksStaffNexus(email, portalKind) {
  if (!portalKind || portalKind === 'soporte') return false;
  return String(email || '').toLowerCase().trim().endsWith('@plexarian.com');
}
